import { DiscordLogo, FacebookLogo, GithubLogo, LinkedinLogo, XLogo } from '@phosphor-icons/react'
import type { SocialLink } from '@/content/schema'

/** OnlineJobs.ph has no Phosphor glyph: its mark, drawn in the current color like the others. */
function OnlineJobsLogo({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path
        fillRule="evenodd"
        d="M3 3h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm4.6 4.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6Zm0 2.3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM17.2 7.4v6.3c0 .8-.4 1.2-1.1 1.2-.5 0-.9-.2-1.2-.5l-1.2 1.7c.7.6 1.6.9 2.6.9 2 0 3.2-1.2 3.2-3.3V7.4h-2.3Z"
      />
    </svg>
  )
}

/** Glyph for a social link (Phosphor brand icons). Add a network: extend `SocialLink['icon']` in
 *  content/schema.ts, add its case here and its hover colour in social-links.css. */
export function SocialIcon({ icon, size = 20 }: { icon: SocialLink['icon']; size?: number }) {
  switch (icon) {
    case 'facebook':
      return <FacebookLogo size={size} weight="fill" aria-hidden />
    case 'linkedin':
      return <LinkedinLogo size={size} weight="fill" aria-hidden />
    case 'discord':
      return <DiscordLogo size={size} weight="fill" aria-hidden />
    case 'github':
      return <GithubLogo size={size} weight="fill" aria-hidden />
    case 'x':
      return <XLogo size={size} weight="bold" aria-hidden />
    case 'onlinejobs':
      return <OnlineJobsLogo size={size} />
  }
}
